import React from "react"
import { Link } from 'gatsby';
import classNames from "classnames";

import styles from "./styles.module.scss";
// import colors from "../../styles/colors.module.scss";
import box from "../../styles/box.module.scss";

// children[0] --> title
// children[1] --> body
const MethodologyCard = ({imageSrc, gotoLink, cardLabel, children}) => (
  <Link to={gotoLink} className={classNames(styles.productCard)}>
    <div className={classNames(styles.productCardHeader)}>
      <div className={classNames(styles.imageLabel)}>{cardLabel}</div>
      <img src={imageSrc} className={classNames(styles.image)} alt={children[0]} />
    </div>
    <div className={classNames(styles.productCardBody, "flex-col-between")}>
      <div className="product-metadata">
        <div className={classNames(styles.productTitle, "edo-h4", box.marginBottom10)}>
          { children[0] }
        </div>
        <div className={classNames(styles.productDescription, "edo-body-text")}>
          { children[1] }
        </div>
      </div>

      <div className={classNames(styles.productLink)}>
        Read more <i className="fas fa-arrow-right" />
      </div>
    </div>
  </Link>
);

export default MethodologyCard;
